/**
 * Carrusel categorías / soluciones (tablet + mobile < 990px).
 * ≥990px: grid estático. Pausa al hover/toque; arrastre manual en mobile/tablet.
 */
(function () {
  var DESKTOP_MQ = '(min-width: 990px)';
  var PX_PER_SECOND = 28;
  var GAP = 24;
  var GAP_MOBILE = 0;

  function getGap(viewportWidth) {
    return viewportWidth < 750 ? GAP_MOBILE : GAP;
  }

  function getVisibleCount(viewportWidth) {
    /* Anchos cercanos al layout original para no deformar la cápsula (radius 999px). */
    if (viewportWidth < 600) return 1.85;
    if (viewportWidth < 750) return 2;
    if (viewportWidth < 990) return 2.35;
    return 3;
  }

  function teardownTrack(track, viewport) {
    if (!track) return;
    track.querySelectorAll('[data-carousel-clone]').forEach(function (node) {
      node.remove();
    });
    track.classList.remove('is-auto-carousel');
    track.style.removeProperty('transform');
    track.style.removeProperty('--oleum-categories-card-width');
    track.dataset.carouselReady = '';

    if (track._carouselCleanup) {
      track._carouselCleanup();
      track._carouselCleanup = null;
    }
    if (viewport) {
      viewport.classList.remove('is-dragging', 'is-auto-carousel-active');
    }
  }

  function setupTrack(track, viewport) {
    if (!track || !viewport || track.dataset.carouselReady === '1') return null;

    var cards = track.querySelectorAll(
      '.oleum-home-categories__card:not([data-carousel-clone])'
    );
    if (cards.length < 2) return null;

    cards.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.carouselClone = '1';
      clone.removeAttribute('id');
      clone.querySelectorAll('a').forEach(function (link) {
        link.tabIndex = -1;
      });
      track.appendChild(clone);
    });

    track.classList.add('is-auto-carousel');
    viewport.classList.add('is-auto-carousel-active');

    var halfWidth = 0;
    var offset = 0;
    var paused = false;
    var dragging = false;
    var pointerDown = false;
    var dragMoved = false;
    var dragStartX = 0;
    var dragStartY = 0;
    var dragStartOffset = 0;
    var activePointerId = null;
    var lastTime = null;
    var rafId = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var inView = true;

    var designCardWidth = 280;

    function measure() {
      var viewportWidth = viewport.clientWidth;
      if (viewportWidth <= 0) return;

      var gap = getGap(viewportWidth);
      var visibleCount = getVisibleCount(viewportWidth);
      var cardWidth = Math.floor(
        (viewportWidth - gap * Math.max(0, Math.ceil(visibleCount) - 1)) / visibleCount
      );
      /* Mantener proporción cápsula: ~165–280px como en el grid original */
      var minWidth = viewportWidth < 750 ? 150 : 240;
      var maxWidth = viewportWidth < 750 ? 180 : 280;
      cardWidth = Math.max(minWidth, Math.min(maxWidth, cardWidth));

      track.style.setProperty('--oleum-categories-card-width', cardWidth + 'px');
      halfWidth = track.scrollWidth / 2;
      if (halfWidth <= 0) return;
      offset = ((offset % halfWidth) + halfWidth) % halfWidth;
    }

    function applyTransform() {
      if (halfWidth <= 0) return;
      track.style.transform = 'translateX(' + (-halfWidth + offset) + 'px)';
    }

    function setPaused(value) {
      paused = value;
    }

    function tick(now) {
      if (!inView) {
        rafId = null;
        lastTime = null;
        return;
      }

      if (!lastTime) lastTime = now;
      var dt = (now - lastTime) / 1000;
      lastTime = now;

      if (!reduceMotion && !paused && !dragging && halfWidth > 0) {
        offset += PX_PER_SECOND * dt;
        if (offset >= halfWidth) offset -= halfWidth;
        applyTransform();
      }

      rafId = requestAnimationFrame(tick);
    }

    function startTick() {
      if (rafId == null) {
        lastTime = null;
        rafId = requestAnimationFrame(tick);
      }
    }

    function stopTick() {
      if (rafId != null) {
        cancelAnimationFrame(rafId);
        rafId = null;
        lastTime = null;
      }
    }

    function onMouseEnter() {
      setPaused(true);
    }

    function onMouseLeave() {
      if (!dragging && !pointerDown) setPaused(false);
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pointerDown = true;
      dragMoved = false;
      dragging = false;
      activePointerId = e.pointerId;
      setPaused(true);
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      dragStartOffset = offset;
    }

    function onPointerMove(e) {
      if (!pointerDown || halfWidth <= 0) return;
      if (activePointerId != null && e.pointerId !== activePointerId) return;

      var dx = e.clientX - dragStartX;
      var dy = e.clientY - dragStartY;

      if (!dragging) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        /* Gesto vertical: soltar y dejar scroll de la página */
        if (Math.abs(dy) > Math.abs(dx)) {
          pointerDown = false;
          activePointerId = null;
          setPaused(false);
          return;
        }
        dragMoved = true;
        dragging = true;
        viewport.classList.add('is-dragging');
        if (viewport.setPointerCapture) {
          try {
            viewport.setPointerCapture(e.pointerId);
          } catch (err) {
            /* noop */
          }
        }
      }

      e.preventDefault();
      /* El carrusel sigue el dedo: derecha → derecha, izquierda → izquierda */
      offset = dragStartOffset + dx;
      offset = ((offset % halfWidth) + halfWidth) % halfWidth;
      applyTransform();
    }

    function endPointer(e) {
      if (!pointerDown && !dragging) return;
      if (activePointerId != null && e.pointerId !== activePointerId) return;
      pointerDown = false;
      dragging = false;
      activePointerId = null;
      viewport.classList.remove('is-dragging');
      if (viewport.releasePointerCapture) {
        try {
          viewport.releasePointerCapture(e.pointerId);
        } catch (err) {
          /* noop */
        }
      }
      if (e.pointerType === 'touch' || e.pointerType === 'pen') {
        setPaused(false);
      } else if (!viewport.matches(':hover')) {
        setPaused(false);
      }
    }

    function onClickCapture(e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }

    function onVisibilityChange() {
      if (document.hidden) stopTick();
      else if (inView) startTick();
    }

    measure();
    applyTransform();
    startTick();

    if (typeof IntersectionObserver !== 'undefined') {
      var visibilityObserver = new IntersectionObserver(
        function (entries) {
          inView = entries[0] && entries[0].isIntersecting;
          if (inView) startTick();
          else stopTick();
        },
        { root: null, threshold: 0.05 }
      );
      visibilityObserver.observe(viewport);
      track._carouselVisibilityObserver = visibilityObserver;
    }

    document.addEventListener('visibilitychange', onVisibilityChange);

    viewport.addEventListener('mouseenter', onMouseEnter);
    viewport.addEventListener('mouseleave', onMouseLeave);
    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove, { passive: false });
    viewport.addEventListener('pointerup', endPointer);
    viewport.addEventListener('pointercancel', endPointer);
    viewport.addEventListener('click', onClickCapture, true);

    track._carouselCleanup = function () {
      stopTick();
      if (track._carouselVisibilityObserver) {
        track._carouselVisibilityObserver.disconnect();
        track._carouselVisibilityObserver = null;
      }
      document.removeEventListener('visibilitychange', onVisibilityChange);
      viewport.removeEventListener('mouseenter', onMouseEnter);
      viewport.removeEventListener('mouseleave', onMouseLeave);
      viewport.removeEventListener('pointerdown', onPointerDown);
      viewport.removeEventListener('pointermove', onPointerMove);
      viewport.removeEventListener('pointerup', endPointer);
      viewport.removeEventListener('pointercancel', endPointer);
      viewport.removeEventListener('click', onClickCapture, true);
    };

    track.dataset.carouselReady = '1';

    return function remeasure() {
      measure();
      applyTransform();
    };
  }

  function initSection(section) {
    if (!section) return;
    var track = section.querySelector('[data-oleum-categories-track]');
    var viewport = section.querySelector('[data-oleum-categories-viewport]');
    if (!track || !viewport || track.dataset.carouselBound === '1') return;
    track.dataset.carouselBound = '1';

    var mqDesktop = window.matchMedia(DESKTOP_MQ);
    var remeasure = null;

    function sync() {
      teardownTrack(track, viewport);
      remeasure = null;
      if (!mqDesktop.matches) {
        remeasure = setupTrack(track, viewport);
      }
    }

    if (typeof mqDesktop.addEventListener === 'function') {
      mqDesktop.addEventListener('change', sync);
    } else if (typeof mqDesktop.addListener === 'function') {
      mqDesktop.addListener(sync);
    }

    window.addEventListener('resize', function () {
      clearTimeout(section._oleumCategoriesResizeTimer);
      section._oleumCategoriesResizeTimer = setTimeout(function () {
        if (remeasure) remeasure();
        else sync();
      }, 150);
    });

    sync();
  }

  function boot(root) {
    (root || document).querySelectorAll('.section-oleum-home-categories').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
